
export const DEFAULT_LOCALE = { locale: 'AE', currency: 'AED', country: 'UAE', symbol: 'AED' };

export const LOCALE_BY_DOMAINS = {
    'me.cleartrip.ae'       :{ locale: 'AE', currency: 'AED', country: 'UAE', symbol: 'AED' },
    'uat.cleartrip.ae'      :{ locale: 'AE', currency: 'AED', country: 'UAE', symbol: 'AED' },
    'www.cleartrip.ae'      :{ locale: 'AE', currency: 'AED', country: 'UAE', symbol: 'AED' },
    'qa2.cleartrip.ae'      :{ locale: 'AE', currency: 'AED', country: 'UAE', symbol: 'AED' },

    'bh.cleartrip.sa'       :{ locale: 'BH', currency: 'BHD', country: 'BHR', symbol: 'BHD' },
    'uat.cleartrip.bh'      :{ locale: 'BH', currency: 'BHD', country: 'BHR', symbol: 'BHD' },
    'www.cleartrip.bh'      :{ locale: 'BH', currency: 'BHD', country: 'BHR', symbol: 'BHD' },
    'qa2bh.cleartrip.sa'    :{ locale: 'BH', currency: 'BHD', country: 'BHR', symbol: 'BHD' },
    
    'om.cleartrip.sa'       :{ locale: 'OM', currency: 'OMR', country: 'OMN', symbol: 'OMR' },
    'uat.cleartrip.om'      :{ locale: 'OM', currency: 'OMR', country: 'OMN', symbol: 'OMR' },
    'www.cleartrip.om'      :{ locale: 'OM', currency: 'OMR', country: 'OMN', symbol: 'OMR' },
    'qa2www.cleartrip.om'   :{ locale: 'OM', currency: 'OMR', country: 'OMN', symbol: 'OMR' },
    
    'kw.cleartrip.sa'       :{ locale: 'KW', currency: 'KWD', country: 'KWT', symbol: 'KWD' },
    'uat.cleartrip.com.kw'  :{ locale: 'KW', currency: 'KWD', country: 'KWT', symbol: 'KWD' },
    'www.cleartrip.com.kw'  :{ locale: 'KW', currency: 'KWD', country: 'KWT', symbol: 'KWD' },
    'qa2www.cleartrip.com.kw'   :{ locale: 'KW', currency: 'KWD', country: 'KWT', symbol: 'KWD' },
    
    'qar.cleartrip.sa'      :{ locale: 'QA', currency: 'QAR', country: 'QAT', symbol: 'QAR' },
    'uat.cleartrip.qa'      :{ locale: 'QA', currency: 'QAR', country: 'QAT', symbol: 'QAR' },
    'www.cleartrip.qa'      :{ locale: 'QA', currency: 'QAR', country: 'QAT', symbol: 'QAR' },
    'qa2www.cleartrip.qa'   :{ locale: 'QA', currency: 'QAR', country: 'QAT', symbol: 'QAR' },
    
    'me.cleartrip.sa'       :{ locale: 'SA', currency: 'SAR', country: 'KSA', symbol: 'SAR' },
    'uat.cleartrip.sa'      :{ locale: 'SA', currency: 'SAR', country: 'KSA', symbol: 'SAR' },
    'www.cleartrip.sa'      :{ locale: 'SA', currency: 'SAR', country: 'KSA', symbol: 'SAR' },
    'qa2.cleartrip.sa'      :{ locale: 'SA', currency: 'SAR', country: 'KSA', symbol: 'SAR' },
    
    'qa2.cleartrip.com'     :{ locale: 'IN', currency: 'INR', country: 'IN', symbol: '₹' },
    'qa2new.cleartrip.com'  :{ locale: 'IN', currency: 'INR', country: 'IN', symbol: '₹' },
    
    'www.cleartrip.me'      :{ locale: 'ME', currency: 'USD', country: 'ME', symbol: '$' },
    'me.cleartrip.com'      :{ locale: 'ME', currency: 'USD', country: 'ME', symbol: '$' },
    'qa2me.cleartrip.com'   :{ locale: 'ME', currency: 'USD', country: 'ME', symbol: '$' },
    
    'www.cleartrip.eu'      :{ locale: 'EU', currency: 'EUR', country: 'EUR', symbol: '€' },
    'www.cleartrip.pl'      :{ locale: 'EU', currency: 'EUR', country: 'EUR', symbol: '€' },
    
    'www.cleartrip.co.za': { locale: 'ZA', currency: 'ZAR', country: 'ZA', symbol: 'R' }
}


export const COUNTRIES_DEFAULT_PROPS =  [
    {   name: 'India', value: 'IN', url: '//www.cleartrip.com' },

    {   name: 'UAE', value: 'AE', url: '//me.cleartrip.ae' },
    {   name: 'UAE', value: 'AE', url: '//uat.cleartrip.ae' },
    {   name: 'UAE', value: 'AE', url: '//www.cleartrip.ae' },

    {   name: 'Oman', value: 'OM', url: '//om.cleartrip.sa' },
    {   name: 'Oman', value: 'OM', url: '//uat.cleartrip.om' },
    {   name: 'Oman', value: 'OM', url: '//www.cleartrip.om' },

    {   name: 'Qatar', value: 'QA', url: '//qar.cleartrip.sa' },
    {   name: 'Qatar', value: 'QA', url: '//uat.cleartrip.qa' },
    {   name: 'Qatar', value: 'QA', url: '//www.cleartrip.qa' },

    {   name: 'Bahrain', value: 'BH', url: '//bh.cleartrip.sa' },
    {   name: 'Bahrain', value: 'BH', url: '//uat.cleartrip.bh' },
    {   name: 'Bahrain', value: 'BH', url: '//www.cleartrip.bh' },

    {   name: 'Kuwait', value: 'KW', url: '//kw.cleartrip.sa' },
    {   name: 'Kuwait', value: 'KW', url: '//uat.cleartrip.com.kw' },
    {   name: 'Kuwait', value: 'KW', url: '//www.cleartrip.com.kw' },

    {   name: 'Saudi Arabia', value: 'SA', url: '//me.cleartrip.sa' },
    {   name: 'Saudi Arabia', value: 'SA', url: '//uat.cleartrip.sa' },
    {   name: 'Saudi Arabia', value: 'SA', url: '//www.cleartrip.sa' },

    {   name: 'Middle East', value: 'ME', url: '//me.cleartrip.com'  }
    // {   name: 'EU', value: 'EU', url: '//www.cleartrip.eu' },
    // {   name: 'Poland', value: 'PL', url: '//www.cleartrip.pl' },
    // {   name: 'South Africa', value: 'ZA', url: '//www.cleartrip.co.za' }
]

export const COUNTRY_MAP = {
    'http://localhost:3031'         : 'SA',
    'https://qa2.cleartrip.com'     : 'IN',
    'https://qa2new.cleartrip.com'  : 'IN',
    'https://www.cleartrip.com'     : 'IN',
    
    'https://me.cleartrip.ae'       : 'AE',
    'https://uat.cleartrip.ae'      : 'AE',
    'https://www.cleartrip.ae'      : 'AE',
    'https://qa2.cleartrip.ae'      : 'AE',
    
    'https://om.cleartrip.sa'       : 'OM',
    'https://uat.cleartrip.om'      : 'OM',
    'https://www.cleartrip.om'      : 'OM',
    
    'https://qar.cleartrip.sa'      : 'QA',
    'https://uat.cleartrip.qa'      : 'QA',
    'https://www.cleartrip.qa'      : 'QA',
    
    'https://bh.cleartrip.sa'       : 'BH',
    'https://uat.cleartrip.bh'      : 'BH',
    'https://www.cleartrip.bh'      : 'BH',
    
    'https://kw.cleartrip.sa'       : 'KW',
    'https://uat.cleartrip.com.kw'  : 'KW',
    'https://www.cleartrip.com.kw'  : 'KW',
    
    'https://me.cleartrip.sa'       : 'SA',
    'https://uat.cleartrip.sa'      : 'SA',
    'https://www.cleartrip.sa'      : 'SA',
    
    'https://me.cleartrip.com'      : 'ME',
    'https://www.cleartrip.eu'      : 'EU',
    'https://www.cleartrip.pl'      : 'PL',
    'https://www.cleartrip.co.za'   : 'ZA'
}

export const DOMAIN_COUNTRY_MAP = {
    ...COUNTRY_MAP,
    'http://localhost:3000': 'IN',
    'https://qa2.cleartrip.sa': 'SA',
    'https://qa2me.cleartrip.com': 'ME',
    'https://qa2www.cleartrip.com.kw': 'KW',
    'https://qa2www.cleartrip.om': 'OM',
    'https://qa2bh.cleartrip.sa': 'BH',
    'https://qa2www.cleartrip.qa': 'QA',
}

export const OFFER_PATH_BY_DOMAIN = {
    'me.cleartrip.ae'       : '/offers/uae',
    'uat.cleartrip.ae'      : '/offers/uae',
    'www.cleartrip.ae'      : '/offers/uae',
    'qa2.cleartrip.ae'      : '/offers/uae',

    'me.cleartrip.sa'       : '/offers/saudi-arabia',
    'uat.cleartrip.sa'      : '/offers/saudi-arabia',
    'www.cleartrip.sa'      : '/offers/saudi-arabia',
    'qa2.cleartrip.sa'      : '/offers/saudi-arabia',

    'bh.cleartrip.sa'       : '/offers/bahrain',
    'uat.cleartrip.bh'      : '/offers/bahrain',
    'www.cleartrip.bh'      : '/offers/bahrain',

    'om.cleartrip.sa'       : '/offers/oman',
    'uat.cleartrip.om'      : '/offers/oman',
    'www.cleartrip.om'      : '/offers/oman',

    'qar.cleartrip.sa'      : '/offers/qatar',
    'uat.cleartrip.qa'      : '/offers/qatar',
    'www.cleartrip.qa'      : '/offers/qatar',

    'kw.cleartrip.sa'       : '/offers/kuwait',
    'uat.cleartrip.com.kw'  : '/offers/kuwait',
    'www.cleartrip.com.kw'  : '/offers/kuwait',


}

export const EXTENTION_BY_DOMAIN = {
    'localhost'             :'in',
    'www.cleartrip.com'     :'in',
    'qa2.cleartrip.com'     :'in',
    'qa2new.cleartrip.com'  :'in',

    'me.cleartrip.ae'       :'ae',
    'uat.cleartrip.ae'      :'ae',
    'www.cleartrip.ae'      :'ae',
    'qa2.cleartrip.ae'      :'ae',
    
    'bh.cleartrip.sa'       :'bh',
    'uat.cleartrip.bh'      :'bh',
    'www.cleartrip.bh'      :'bh',
    
    'om.cleartrip.sa'       :'om',
    'uat.cleartrip.om'      :'om',
    'www.cleartrip.om'      :'om',
    
    'kw.cleartrip.sa'       :'kw',
    'uat.cleartrip.com.kw'  :'kw',
    'www.cleartrip.com.kw'  :'kw',
    
    'qar.cleartrip.sa'      :'qa',
    'uat.cleartrip.qa'      :'qa',
    'www.cleartrip.qa'      :'qa',
    
    'me.cleartrip.sa'       :'sa',
    'uat.cleartrip.sa'      :'sa',
    'www.cleartrip.sa'      :'sa',
    'qa2.cleartrip.sa'      :'sa',
    
    'me.cleartrip.com'      :'me',
    'www.cleartrip.me'      :'me'
}
